import React, { useState } from "react";
import { Alert, Box, Button, CircularProgress, Grid, Snackbar, Typography } from "@mui/material";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import HeaderCerberus from "./components/HeaderCerberus";
import TableCerberus from "./components/TableCerberus";
import LogStreamModal from "./components/LogStreamModal";
import { useCerberus } from "./hooks/useCerberus";
import { formatCerberusDate } from "./model/cerberusModel";
export default function Cerberus() {
  const data = useCerberus();
  const [selected, setSelected] = useState(null);
  const [notice, setNotice] = useState(null);
  const refresh = async () => {
    const result = await data.refreshData();
    if (result)
      setNotice({
        severity: result.success ? "success" : "error",
        message: result.success ? "Listado actualizado correctamente." : result.error,
      });
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ py: 3 }}>
        <HeaderCerberus
          onRefresh={refresh}
          loading={data.loading}
          filtros={data.filtros}
          onFiltroChange={data.setFiltro}
          onClearFilters={data.clearFilters}
          ipsUnicas={data.ipsUnicas}
        />
        <Grid container spacing={2} sx={{ my: 1 }}>
          {[
            ["Registros en la vista", data.stats.total, "#edf3fb", "#315e89"],
            ["Activos", data.stats.activos, "#eaf6ef", "#226346"],
            ["Inactivos", data.stats.inactivos, "#f0f2f6", "#59677d"],
            ["Hosts en la vista", data.stats.hosts, "#eef0fb", "#4657a1"],
          ].map(([label, value, bg, color]) => (
            <Grid key={label} item xs={6} md={3}>
              <Box sx={{ bgcolor: bg, border: `1px solid ${color}25`, borderRadius: 2, p: 2 }}>
                <Typography sx={{ fontSize: 26, fontWeight: 700, color }}>{value}</Typography>
                <Typography sx={{ fontSize: 13, fontWeight: 600, color }}>{label}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
        <Typography sx={{ my: 2, fontSize: 12, color: "#60788c" }}>
          Contadores según los filtros · {data.stats.eliminados} eliminados ·{" "}
          {data.stats.desconocidos} sin información. Última carga correcta:{" "}
          {formatCerberusDate(data.lastUpdated)}
          {data.lastUpdated ? " · Colombia" : ""}
        </Typography>
        {data.error && (
          <Alert
            severity="error"
            sx={{ mb: 2 }}
            action={
              <Button color="inherit" disabled={data.loading} onClick={refresh}>
                Reintentar
              </Button>
            }
          >
            {data.error}
            {data.lastUpdated ? " Se conserva el último listado cargado." : ""}
          </Alert>
        )}
        {data.loading && (
          <Box sx={{ display: "flex", justifyContent: "center", gap: 2, py: 3 }}>
            <CircularProgress size={24} />
            <Typography sx={{ fontSize: 14, color: "#506b80" }}>
              Actualizando fuentes de logs…
            </Typography>
          </Box>
        )}
        {(!data.loading || data.todosLogs.length > 0) && (
          <TableCerberus
            logs={data.logs}
            totalLogs={data.todosLogs.length}
            onViewDetails={setSelected}
          />
        )}
        <LogStreamModal
          open={!!selected}
          logInfo={selected}
          streamUrl={selected?.streamUrl}
          onClose={() => setSelected(null)}
        />
        <Snackbar open={!!notice} autoHideDuration={5000} onClose={() => setNotice(null)}>
          <Alert severity={notice?.severity || "info"} onClose={() => setNotice(null)}>
            {notice?.message}
          </Alert>
        </Snackbar>
      </Box>
    </DashboardLayout>
  );
}
